<template>
    <b-modal
            v-model="show"
            centered
            no-close-on-backdrop
            size="md"
            title="Создание акции"
            @hide="close(false)"
    >
        <b-container fluid>
            <b-row no-gutters class="mb-2">
                <b-col>
                    <label class="custom-input-label">Организация <span class="mark-required">*</span></label>
                    <b-select
                            :disabled="!isAdmin"
                            :options="getSortedOrgItems"
                            value-field="id"
                            text-field="orgName"
                            placeholder="Выберите организацию"
                            v-model="editModel.organizationId"
                            :state="errors.findIndex(x=>x.key='organizationId')!=-1?editModel.organizationId!=null&&editModel.organizationId!=''?true:false:null"
                    />
                </b-col>
            </b-row>
            <b-row no-gutters class="mb-2">
                <b-col>
                    <label class="custom-input-label">Название акции <span class="mark-required">*</span></label>
                    <b-input
                            placeholder="Введите название акции"
                            v-model="editModel.stockTitle"
                            required
                            :state="errors.findIndex(x=>x.key='stockTitle')!=-1?editModel.stockTitle!=null?true:false:null"
                    />
                </b-col>
            </b-row>
            <b-row no-gutters class="mb-2">
                <b-col>
                    <label class="custom-input-label">Описание</label>
                    <b-textarea
                            placeholder="Введите подробное описание акции"
                            rows="4"
                            v-model="editModel.stockDescription"
                            required
                    />
                </b-col>
            </b-row>
            <b-row no-gutters class="mb-1">
                <b-col>
                    <label class="custom-input-label">Дата начала акции <span class="mark-required">*</span></label>
                    <b-input
                            type="date"
                            placeholder="дд.ММ.гггг"
                            v-model="editModel.dateStart"
                            :state="errors.findIndex(x=>x.key='dateStart')!=-1?editModel.dateStart!=null?true:false:null"
                    />
                </b-col>
            </b-row>
            <b-row no-gutters class="mb-1">
                <b-col>
                    <label class="custom-input-label">Дата окончания акции <span class="mark-required">*</span></label>
                    <b-input
                            type="date"
                            placeholder="дд.ММ.гггг"
                            v-model="editModel.dateEnd"
                            :state="errors.findIndex(x=>x.key='dateEnd')!=-1?editModel.dateEnd!=null?true:false:null"
                    />
                </b-col>
            </b-row>
            <b-row class="mb-1">
                <b-col>
                    <label class="custom-input-label">Размер плитки <span class="mark-required">*</span></label>
                    <b-select
                            v-model="editModel.stockSize"
                            :state="errors.findIndex(x=>x.key='stockSize')!=-1?editModel.stockSize!=null?true:false:null"
                            :options="sizesStock"
                    />
                </b-col>
            </b-row>
            <b-row no-gutters class="mb-1">
                <b-col>
                    <label class="custom-input-label">Изображение акции (354 x 354)</label>
                    <imageLoader style="width: 100px;" size="smallAdd" :ratioH="1" :editedImage="editModel.stockImage"
                                 textLabel=" " @file-loaded="logoLoaded"></imageLoader>
                </b-col>
            </b-row>
            <b-row no-gutters class="mb-1">
                <b-col>
                    <label class="custom-input-label">Изображение в детализации акции(1080 x 540)</label>
                    <imageLoader style="width: 200px;" size="bigAdd" :editedImage="editModel.stockDetailImage"
                                 textLabel=" " @file-loaded="bigLogoLoaded"></imageLoader>
                </b-col>

            </b-row>

        </b-container>
        <template v-slot:modal-footer>
            <div class="w-100">
                <v-row no-gutters justify="space-between">

                    <v-spacer></v-spacer>
                    <v-col cols="auto" class="mr-2">
                        <v-btn
                                color="var(--color-blue)"
                                dark
                                size="sm"
                                @click="onSave"
                        >
                            Сохранить
                        </v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn
                                class="cancel-btn"
                                outlined
                                color="var(--color-3)"
                                size="sm"
                                @click="close(false)"
                        >
                            Отмена
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import imageLoader from '../ImageLoader.vue'
    import axios from 'axios'

    const apiLink = process.env.VUE_APP_API_LINK
    import {mapGetters} from 'vuex'

    export default {
        name: "AddStockModal",
        props: {
            show: Boolean
        },
        components: {imageLoader},
        data() {
            return {
                errors: [],
                imageModel: null,
                imageDetailModel: null,
                editModel: {
                    id: null,
                    organizationId: null,
                    organization: null,
                    stockImage: null,
                    stockDetailImage: null,
                    stockVideo: null,
                    stockTitle: null,
                    stockDescription: null,
                    stockSize: null,
                    isActive: true,
                    dateEnd: null,
                    dateStart: null,
                },
            }
        },

        computed: {
            ...mapGetters({
                getSortedOrgItems: "Stocks/getSortedOrgItems"
            }),

            isAdmin() {
                let user = this.$store.state.userData.webUser
                if (user != null) {
                    return user.isAdmin
                }
                else return false
            },

            sizesStock() {
                return this.$store.state.Stocks.sizesStock;
            },

        },
        methods: {

            logoLoaded(e) {
                this.imageModel = e[0]
                if (e[0] == null)
                    this.editModel.stockImage = null
            },
            bigLogoLoaded(e) {
                this.imageDetailModel = e[0]
                if (e[0] == null)
                    this.editModel.stockDetailImage = null
            },

            resetModel() {
                for (var key in this.editModel) {
                    if (key == 'isActive') {
                        this.editModel[key] = true;
                    } else
                        this.editModel[key] = null;
                }
                this.errors = [];
                this.imageDetailModel = null;
                this.imageModel = null;
                if (this.isAdmin == false) {
                    let user = this.$store.state.userData.webUser
                    this.editModel.organizationId = user != null ? this.$store.state.userData.webUser.organizationId : null
                }
            },

            close(isSave) {
                this.$emit("close", isSave)
            },

            validateModel() {
                var noError = true;
                this.errors = [];
                if (this.editModel.organizationId == null || this.editModel.organizationId == '') {
                    this.errors.push({key: "organizationId", mes: "Необходимо указать организацию!"});
                    noError = false;
                }

                if (this.editModel.stockTitle == null || this.editModel.stockTitle == '') {
                    this.errors.push({key: "stockTitle", mes: "Необходимо указать название акции!"});
                    noError = false;
                }
                if (this.editModel.stockSize == null) {
                    this.errors.push({key: "stockSize", mes: "Необходимо выбрать размер плитки!"});
                    noError = false;
                }

                if (this.imageModel == null && this.editModel.stockImage == null) {
                    this.errors.push({key: "mediaModel", mes: "Необходимо загрузить один из медиа файлов!"});
                    noError = false;
                }

                if (this.imageDetailModel == null && this.editModel.stockDetailImage == null) {
                    this.errors.push({key: "imageDetailModel", mes: "Необходимо загрузить изображение детализации!"});
                    noError = false;
                }
                if (this.editModel.dateEnd == null) {
                    this.errors.push({key: "dateEnd", mes: "Необходимо указать дату окончания!!"});
                    noError = false;
                }
                if (this.editModel.dateStart == null) {
                    this.errors.push({key: "dateStart", mes: "Необходимо указать дату начала акции!!"});
                    noError = false;
                }

                return noError;
            },

            async onSave() {
                if (this.validateModel() == true) {
                    const vm = this;
                    //если была изменена картинка, то загружаем на сервер
                    if (this.imageModel != null) {
                        var imgId = null;
                        const imgData = new FormData();
                        imgData.append('files', this.imageModel);
                        await axios.post(`${apiLink}FileUpload`, imgData)
                            .then(response => imgId = response.data[0])
                            .catch(error => {
                                console.log(error)
                            });
                        if (imgId != null)
                            this.editModel.stockImage = imgId;
                    }

                    if (this.imageDetailModel != null) {
                        var imgId = null;
                        const imgData = new FormData();
                        imgData.append('files', this.imageDetailModel);
                        await axios.post(`${apiLink}FileUpload`, imgData)
                            .then(response => imgId = response.data[0])
                            .catch(error => {
                                console.log(error)
                            });
                        if (imgId != null)
                            this.editModel.stockDetailImage = imgId;
                    }


                    this.$store.dispatch('Stocks/addStock', this.editModel).then(() => {

                            this.$bvToast.toast("Акция успешно добавлена", {
                                variant: "success",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                            this.close(true)
                        }
                    ).catch((err) => {
                        this.$bvToast.toast(err.message, {
                            title: `Ошибка!`,
                            variant: "danger",
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 3000,
                            solid: true
                        })
                    });


                }
                else {
                    this.errors.forEach(err => {
                        this.$bvToast.toast(err.mes, {
                            title: `Не все поля заполнены!`,
                            variant: "warning",
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 7000,
                            solid: true
                        })
                    })
                }
            },
        },
        watch: {
            show(value) {
                if (value == true) {
                    this.resetModel()
                }
            }
        }
    }
</script>

<style scoped>

</style>